import React from 'react';
import styles from './index.module.less';
import { FooterContext } from '../../common';

const CompFooterOtherInfo: React.FC = () => {
    const { getTextByKey } = React.useContext(FooterContext);

    return (
        <div className={ styles['other-info-wrapper'] }>
            <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.dmca.com/Protection/Status.aspx?ID=b09397d7-7449-489d-8965-e6a9272b603a&refurl=https://reolink.com/"
                className={ styles['dmca-link'] }
            >
                <img
                    src="https://images.dmca.com/Badges/dmca_protected_sml_120l.png?ID=b09397d7-7449-489d-8965-e6a9272b603a"
                    alt="DMCA.com Protection Status"
                />
            </a>
            <p className={ styles['other-info-text'] }>{getTextByKey('other-info-text')}</p>
        </div>
    );
};

export default CompFooterOtherInfo;
